import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state:{
        name:'StoreValue',
        BaseImgUrl:'', // 图片域名
        fromRoute:'',  // 当前页面来自的路由
        processList:[], // 选中的工序列表
    }
})


export default store


// WEBPACK FOOTER //
// ./src/store/index.js